//Standard
const HomePage = () => import('@/views/home/HomePage.vue');
const WorkerManagement = () => import('@/views/worker/WorkerManagement.vue');
const ProjectManagement = () => import('@/views/project/ProjectManagement.vue');
const CustomerManagement = () => import('@/views/customer/CustomerManagement.vue');
// const DailyWorkReportManagement = () => import('@/views/dailyWorkReport/DailyWorkReportManagement.vue');
const BasicDataManagement = () => import('@/views/administration/basicData/BasicDataManagement.vue');
//const SingleTimeRecordEditor = () => import('@/components/record/singleTimeRecord/SingleTimeRecordEditor.vue');

// Report generation
const ProjectTimeReportManagementView = () => import('@/views/ProjectTimeReportManagementView.vue');
const WorkerTimeReportManagementView = () => import('@/views/WorkerTimeReportManagementView.vue');

//Contacts
const ContactPersonManagement = () => import('@/views/contactPerson/ContactPersonManagement.vue');
const OrganizationManagement = () => import('@/views/organization/OrganizationManagement.vue');

//Administration
const LLogin = () => import('@/views/auth/login/LLogin.vue');
const UpdatePassword = () => import('@/views/auth/updatePassword/UpdatePassword.vue');
const LoginManagement = () => import('@/views/administration/login/LoginManagement.vue');
const GroupManagement = () => import('@/views/administration/group/GroupManagement.vue');
const DataBaseManagement = () => import('@/views/administration/database/DataBaseManagement.vue');

//TimeManagement
const WorkerTimeManagement = () => import('@/views/time/workerTime/WorkerTimeManagement.vue');
// const WorkerTimeManagementOverview = () => import('@/views/time/workerTime/WorkerTimeManagementOverview.vue');
// const PeriodTimeManagement = () => import('@/views/time/periodTime/PeriodTimeManagement');

// MIS
// const DashboardManagement = () => import('@/views/bi/dashboard/DashboardManagement.vue');
// const MapManagement = () => import('@/views/bi/map/MapManagement.vue');
// const KPIManagement = () => import('@/views/bi/map/KPIManagement.vue');

//Mobile
// const ProjectTimeReportMobileWindow = () => import('@/views/projectTimeReport/mobile/ProjectTimeReportMobileWindow.vue');
// const ProjectTimeReportMobileManagement = () =>
// 	import('@/views/projectTimeReport/mobile/ProjectTimeReportMobileManagement.vue');
// const HomeMobile = () => import('@/views/home/mobile/HomeMobile.vue');

//Dev
// const devTest = () => import('@/views/DevTest.vue');

// Frontend-Roles
// eslint-disable-next-line no-unused-vars
import { admin, office, powerUser, user } from './frontendRoles';

// Note: If the icon property is undefined/null, the route will be available,
// but not rendered in the navigation.

export const navigationStructure = [
	{
		path: '/',
		name: 'home',
		component: HomePage,
		icon: 'mdi-home',
		description: 'The home section offers an overview of the activated applications.',
		meta: {
			roles: [user, powerUser, office, admin],
		},
	},
	// {
	// 	name: 'mis',
	// 	icon: 'mdi-monitor-dashboard',
	// 	sub: [
	// 		{
	// 			path: '/mis/dashboard',
	// 			name: 'dashboard',
	// 			component: DashboardManagement,
	// 			icon: 'mdi-view-dashboard',
	// 			meta: {
	// 				roles: [powerUser, office, admin],
	// 			},
	// 		},
	// 		{
	// 			path: '/mis/map',
	// 			name: 'map',
	// 			component: MapManagement,
	// 			icon: 'mdi-map-marker-multiple', //mdi-earth  outline
	// 			meta: {
	// 				roles: [powerUser, office, admin],
	// 			},
	// 		},
	// 		// {
	// 		// 	path: '/mis/kpi',
	// 		// 	name: 'kpi',
	// 		// 	component: KPIManagement,
	// 		// 	icon: 'mdi-map-marker-multiple', //mdi-earth  outline
	// 		// 	meta: {
	// 		// 		roles: [powerUser, office, admin],
	// 		// 	},
	// 		// },
	// 	],
	// },
	{
		name: 'times',
		icon: 'mdi-folder-clock-outline',
		sub: [
			{
				path: '/times/workerTimes',
				name: 'workerTimes',
				component: WorkerTimeManagement,
				icon: 'mdi-account-clock',
				meta: {
					roles: [user, powerUser, office, admin],
				},
			},
			// {
			// 	path: '/times/workerTimesOverview',
			// 	name: 'workerTimesOverview',
			// 	component: WorkerTimeManagementOverview,
			// 	icon: 'mdi-table-clock',
			// 	meta: {
			// 		roles: [user, powerUser, office, admin],
			// 	},
			// },
			// {
			// 	path: '/times/periodTimes',
			// 	name: 'periodTimes',
			// 	component: PeriodTimeManagement,
			// 	icon: 'mdi-calendar-clock',
			// 	meta: {
			// 		roles: [powerUser, office, admin],
			// 	},
			// },
		],
	},

	{
		path: '/projects',
		name: 'projects',
		hotkey: 'F3',
		component: ProjectManagement,
		icon: 'mdi-folder-multiple-outline',
		description: 'Manage your projects',
		meta: {
			roles: [powerUser, office, admin],
		},
	},
	{
		name: 'reportManagement',
		icon: 'mdi-file-document-multiple-outline',
		sub: [
			{
				path: '/reports/dailyProjectReports',
				name: 'dailyProjectReports',
				hotkey: 'F6',
				component: ProjectTimeReportManagementView,
				icon: 'mdi-file-document-multiple-outline',
				description: 'Manage your ProjectReports',
				meta: {
					roles: [powerUser, office, admin],
				},
			},
			{
				path: '/reports/dailyWorkerReports',
				name: 'workerTimeReports',
				hotkey: 'F10',
				component: WorkerTimeReportManagementView,
				icon: 'mdi-file-document-multiple-outline',
				description: 'Manage your WorkerReports',
				meta: {
					roles: [powerUser, office, admin],
				},
			},
		],
	},
	{
		path: '/customers',
		name: 'customers',
		hotkey: 'F5',
		component: CustomerManagement,
		icon: 'mdi-folder-account-outline',
		description: 'Manage your Customers',
		meta: {
			roles: [powerUser, office, admin],
		},
	},

	{
		name: 'contacts',
		icon: 'mdi-card-account-details-outline',

		sub: [
			{
				path: '/contacts/organizations',
				name: 'organizations',
				hotkey: 'F9',
				component: OrganizationManagement,
				icon: 'mdi-folder-home-outline',
				description: 'Manage your Companies',
				meta: {
					roles: [powerUser, office, admin],
				},
			},
			{
				path: '/contacts/persons',
				name: 'persons',
				hotkey: 'F7',
				component: ContactPersonManagement,
				icon: 'mdi-card-account-phone-outline',
				description: 'Manage your Contacts',
				meta: {
					roles: [powerUser, office, admin],
				},
			},
		],
	},

	{
		path: '/workers',
		name: 'workers',
		hotkey: 'F2',
		component: WorkerManagement,
		icon: 'mdi-account-hard-hat',
		description: 'Manage your workers',
		meta: {
			roles: [powerUser, office, admin],
		},
	},
	{
		path: '/login',
		name: 'login',
		component: LLogin,
		// icon: 'mdi-file-document-multiple',
		description: 'Login',
	},
	{
		path: '/updatePassword',
		name: 'updatePassword',
		component: UpdatePassword,
		// icon: 'mdi-file-document-multiple',
		description: 'Password-Update',
	},
	{
		name: 'administration',
		icon: 'mdi-account-cog',

		sub: [
			{
				path: '/administration/users',
				name: 'users',
				component: LoginManagement,
				icon: 'mdi-account',
				meta: {
					roles: [office, admin],
				},
			},
			{
				path: '/administration/group',
				name: 'groups',
				component: GroupManagement,
				icon: 'mdi-account-group',
				meta: {
					roles: [office, admin],
				},
			},
			{
				path: '/administration/basic-data',
				name: 'basicData',
				component: BasicDataManagement,
				icon: 'mdi-database-cog-outline',
				meta: {
					roles: [office, admin],
				},
			},
			{
				path: '/administration/database',
				name: 'databases',
				component: DataBaseManagement,
				icon: 'mdi-database-sync-outline',
				meta: {
					roles: [admin],
				},
			},
		],
	},
	// {
	// 	path: '/devTest',
	// 	name: 'devTest',
	// 	hotkey: 'F7',
	// 	component: devTest,
	// 	icon: 'mdi-file-document-multiple',
	// 	description: 'devTest.',
	// },
];

export const routes = [];
for (const route of navigationStructure) {
	if (route.sub) {
		routes.push(...route.sub);
	} else {
		routes.push(route);
	}
}
